import React from 'react'

const AffiliateComponent = () => {
    return (
        <div>
            <div>
                <h1>Affiliate Codes</h1>
            </div>
            <div>
                <h2>Coming soon...</h2>
            </div>
        </div>
    )
}

export default AffiliateComponent